import React from 'react';
import Layout from '../../components/layout';
import Industry from '../../components/one-oh-one/Industry';

const headerText = 'SUBSTANCE USE 101';

const OneOhOne = () => {
  return (
    <Layout
      headerText={headerText}
      heroFont="has-text-white"
      heroBg="dark-hero"
    >
      <Industry path="/one-oh-one/industry" />
    </Layout>
  );
};

export default OneOhOne;
